// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d013cde8","455":"c4a183b1","977":"101c3444"}[chunkId] + ".chunk.js";
};